<template>
  <div id="bsModalLocation" aria-labelledby="bsModalLocationLabel" class="modal fade"
       data-backdrop="static" data-keyboard="false"
       data-toggle="modal" role="dialog" tabindex="-1" @click="clickOverlay()">
    <div class="modal-dialog" role="document" @click.stop>
      <div class="modal-content">
        <div class="modal-header">
          <button aria-label="Close" class="close" type="button" @click="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 id="bsModalLocationLabel" class="modal-title">{{ title }}</h4>
        </div>
        <div class="modal-body">
          <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
              <ValidationProvider v-slot="{ errors }" class="form-group"
                                  name="latitude" rules="required" tag="div">
                <label for="lat">Latitude</label>
                <input type="text" id="lat" v-model="form.Latitude" class="form-control"/>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <ValidationProvider v-slot="{ errors }" class="form-group"
                                  name="longitude" rules="required" tag="div">
                <label for="lng">Latitude</label>
                <input type="text" id="lng" v-model="form.Longitude" class="form-control"/>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <div class="text-right">
                <button :disabled="isLoading" class="btn btn-primary btn-flat" type="submit">
                  Update
                  <span v-if="isLoading">
                    <i class="fa fa-circle-o-notch fa-spin ml-8"></i>
                  </span>
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { logout, saveNotification } from '@/lib/utils'

export default {
  name: 'LocationModal',
  data() {
    return {
      isLoading: false,
      title: '',
      user: null,
      form: {
        Latitude: '',
        Longitude: ''
      },
      confirmHook: () => {
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
  methods: {
    confirm: function(location) {
      this.confirmHook(location)
      this.close()
    },
    onSubmit: function() {
      this.isLoading = true
      const apiBaseUrl = process.env.VUE_APP_API_URL
      const encodeForm = data => {
        return Object.keys(data).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&')
      }
      const payload = {
        Call: 'LocationUpdate',
        ID: this.user.ID,
        MerchantID: this.currentUser.ID,
        APIKey: this.currentUser.APIKey,
        Latitude: this.form.Latitude,
        Longitude: this.form.Longitude,
        output: 'json'
      }
      this.$http.post(`${apiBaseUrl}/v2REAPI`, encodeForm(payload), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        this.isLoading = false
        if (response.data.status_code === 200) {
          if (response.data.result.toLowerCase() === 'success') {
            this.$toast.fire('', 'Location updated successfully', 'success')
            saveNotification('Location updated successfully')
            this.confirm({
              Latitude: payload.Latitude,
              Longitude: payload.Longitude
            })
          }
        } else if (response.data.status_code === 400) {
          if (response.data.message.toLowerCase() === 'no permission') {
            logout()
          }
        }
      }).catch(error => {
        console.log(error)
        this.isLoading = false
      })
    },
    clickOverlay: function() {
      // Hide modal
      this.close()
    },
    close() {
      this.form = {
        Latitude: '',
        Longitude: ''
      }
      this.$nextTick(() => this.$refs.observer.reset())
      $('#bsModalLocation').modal('hide')
    }
  },
  mounted() {
    this.$bus.$on('location-modal', (args) => {
      this.title = args.title
      this.user = args.data || null
      if (this.user) {
        this.form = {
          Latitude: this.user.Latitude,
          Longitude: this.user.Longitude
        }
      }
      this.confirmHook = args.confirm
      $('#bsModalLocation').modal('show')
    })
  }
}
</script>

<style scoped></style>
